module.exports = __webpack_public_path__ + "img/7.49c13cb8.jpg";